import React, {useEffect, useState} from 'react';
import {ProgressSpinner} from "primereact/progressspinner";
import {useEntityObject} from "../../../dynamic365";
import {Note} from "../../../dynamic365/entities/Note";

function DocumentItem({annotationid, filename}){
    const note = useEntityObject(Note());
    const [documentBody, setDocumentBody] = useState();
    useEffect(()=>{
        note.fetch({
            filters:{annotationid},
            onResult:(result)=>{
                setDocumentBody(result.data.value[0].documentbody);
            }
        })
    },[])
    return(
        <div className="h-8rem flex align-items-center justify-content-center">
            {documentBody ? (<img alt={filename} className="h-full border-round border-1 border-primary" src={`data:image/jpeg;base64,${documentBody}`}/>):<ProgressSpinner className="w-8rem h-4rem" />}

        </div>
    )
}

export default DocumentItem;